class InfiniteScroll extends HTMLElement {
	constructor() {
		super();

		this.addEventListener('click', this.onClickHandler.bind(this));

		if (this.dataset.trigger == 'infinite') {
			new IntersectionObserver(this.handleIntersection.bind(this), { rootMargin: '0px 0px 200px 0px' }).observe(this);
		}
	}

	onClickHandler() {
		if (this.classList.contains('loading') || this.classList.contains('disabled')) return;
		this.classList.add('loading');
		this.classList.add('disabled');
		const loader = this.querySelector(".loading__spinner");

		if (loader) loader.classList.remove("hidden");

		const sections = InfiniteScroll.getSections();
		sections.forEach(() => {
			const url = this.dataset.url;
			InfiniteScroll.renderSectionFromFetch(url, this);
		});
	}

	handleIntersection(entries, observer) {
		if (!entries[0].isIntersecting) return;
		observer.unobserve(this);

		this.onClickHandler();
	}

	static getSections() {
		return [
			{
				section: document.getElementById('product-grid').dataset.id,
			}
		];
	}

	static renderSectionFromFetch(url, ele) {
		fetch(url)
			.then(response => response.text())
			.then((responseText) => {
				const html = responseText;
				InfiniteScroll.renderPagination(html);
				InfiniteScroll.renderProductGridContainer(html);

				const loader = ele.querySelector(".loading__spinner");
				ele.classList.remove("loading");
				ele.classList.remove("disabled");
				if (loader) loader.classList.add("hidden");
			})
			.catch((e) => {
				console.error(e);
			});
	}

	static renderPagination(html) {
		const container = document.getElementById('ProductGridContainer') ? document.getElementById('ProductGridContainer').querySelector('.pagination-wrapper') : null;
		const parsedDoc = new DOMParser().parseFromString(html, 'text/html');
		const newGridContainer = parsedDoc.getElementById('ProductGridContainer');
		const pagination = newGridContainer ? newGridContainer.querySelector('.pagination-wrapper') : null;
		if (container && pagination) {
			container.innerHTML = pagination.innerHTML;
		}
	}

	static renderProductGridContainer(html) {
		const container = document.getElementById('product-grid');
		const productGrid = new DOMParser().parseFromString(html, 'text/html').getElementById('product-grid');
		const showSubBanners = container && productGrid ? container.getAttribute("data-show-sub-banners") : null;
		const showSubFilters = container && productGrid ? container.getAttribute("data-show-sub-filters") : null;

		// Select all product items from the grid
		const products = productGrid.querySelectorAll("li.grid__item");

		// Total products that are already present inside the container
		const renderedProducts = container.querySelectorAll("li.grid__item");

		// Media query listeners for mobile and desktop breakpoints
		const mobileQuery = window.matchMedia("(max-width: 749px)");
		const desktopQuery = window.matchMedia("(min-width: 750px)");

		if (products.length > 0) {
			checkScreenSize(mobileQuery, "mobile");
			checkScreenSize(desktopQuery, "desktop");
		}

		// CHECK SCREEN SIZE AND EXECUTE LOGIC.....
		function checkScreenSize(screenQuery, screenConfig) {

			if (screenQuery.matches) {

				const viewPort = screenConfig === "mobile" ? "mobile" : "desktop";

				if (showSubBanners === "true") {
					getImageURLs("data-prev-image-index", `data-${viewPort}-banners`, `data-banner-interval-${viewPort}`);
				}
				if (showSubFilters === "true") {
					getSubFiltersData("data-prev-filter-index", `data-sub-filters-interval-${viewPort}`);
				}
			}
		}

		// EXTRACT IMAGE URLS, BANNER INTERVAL AND PREVIOUS IMAGE INDEX.....
		function getImageURLs(attr1, attr2, attr3) {

			const previousImageIndex = parseInt(container.getAttribute(attr1)) || 0;
			const bannerURLs = container.getAttribute(attr2) || '';
			const bannerInterval = parseInt(container.getAttribute(attr3)) || 8

			if (isNaN(previousImageIndex) || isNaN(bannerInterval)) return;

			// Calucate products that are left below the last image banner
			const balanceProducts = renderedProducts && renderedProducts.length > 0 ? renderedProducts.length % bannerInterval : 0

			renderBannerImages(previousImageIndex, bannerURLs, bannerInterval, balanceProducts);
		}

		// EXTRACT SUB-FILTERS INTERVAL AND PREVIOUS FILTER INDEX.....
		function getSubFiltersData(attr1, attr2) {
			const previousFilterIndex = parseInt(container.getAttribute(attr1)) || 0;
			const filterPlacementInterval = parseInt(container.getAttribute(attr2)) || 8;
			const subFilters = container.querySelector(".subfilters")

			if (isNaN(filterPlacementInterval)) return;

			// Calucate products that are left below the last image banner
			const balanceProducts = renderedProducts && renderedProducts.length > 0 ? renderedProducts.length % filterPlacementInterval : 0

			renderSubFilters(previousFilterIndex, subFilters, filterPlacementInterval, balanceProducts);
		}

		// RENDER BANNER IMAGES.....
		function renderBannerImages(prevIndex, banners, interval, balance) {
			if (banners) {
				const bannerArray = banners.split(",");

				if (bannerArray.length > 0) {
					let currIndex = prevIndex + 1; // Start with the next image index

					// Reset the index if it exceeds the length of the array
					if (currIndex === bannerArray.length) currIndex = 0;

					// Update currentInterval based on number of products left available before
					let currentInterval = balance === 0 ? interval : Math.abs(balance - interval)

					products.forEach((product, index) => {

						// Check if the product is the right position based on the interval
						const value = (index + 1) % currentInterval;

						if (value === 0) {

							// Update the container with the current image index. This will be used during infinite scroll, to check what's the last image rendered.
							container.setAttribute('data-prev-image-index', currIndex);

							// If there are banner URLs available, create and insert the image element
							let currImage = bannerArray[currIndex];

							const imageElement = document.createElement('img');
							imageElement.src = currImage;

							// Insert the image element after the current product element
							product.insertAdjacentElement('afterend', imageElement);

							// Move to the next image in the array. By using Modulo with array length it won't exceeds the array length
							currIndex = (currIndex + 1) % bannerArray.length;

							// Update currentInterval so that next image will render after proper interval of rows
							currentInterval = interval + currentInterval
						}
					});
				}
			}
		}

		// RENDER SUB-FILTERS.....
		function renderSubFilters(prevIndex, subfilters, interval, balance) {
			if (!subfilters) return;

			const filters = subfilters.querySelectorAll(".filter_element")
			if (filters.length === 0) return;

			let currIndex = prevIndex + 1;
			if (currIndex === filters.length) currIndex = 0;

			let currentInterval = balance === 0 ? interval : Math.abs(balance - interval);

			products.forEach((product, index) => {

				const value = (index + 1) % currentInterval;

				if (value === 0) {
					container.setAttribute('data-prev-filter-index', currIndex);

					const newElement = subfilters.cloneNode(true)

					if (newElement) {
						const filterElements = newElement.querySelectorAll(".filter_element")

						if (filterElements && filterElements.length > 0) {
							filterElements.forEach(ele => ele.classList.add("hidden"))

							newElement.classList.remove("hidden")
							filterElements[currIndex].classList.remove("hidden")
						}
					}

					product.insertAdjacentElement('afterend', newElement);

					currIndex = (currIndex + 1) % filters.length;
					currentInterval = interval + currentInterval; // Adjust interval for next filter
				}
			});
		}

		container.insertAdjacentHTML('beforeend', productGrid.innerHTML);

		// Set eventlisteners to labels and pass the input ids to the apply filter
		window.setInputIDs()

		// Show the loading effect for the newly added products
		const cardImages = container.querySelectorAll(".card__media img")
		window.showImageLoading(cardImages)
	}
}

customElements.define('infinite-scroll', InfiniteScroll);